<template>
    <multiselect v-model="DisplayValue" :options="options" :multiple="false" track-by="name" :clear-on-select="false" :show-labels="false" label="name" placeholder="Select Country" :preselect-first="true">

    </multiselect>

</template>
<script>
    import Multiselect from 'vue-multiselect'
    export default {
        name: 'CountryDropdown',
        props: ["values"],
        components: {
            Multiselect,

        },
        data: function () {
            return {
                options: [],
                value: '',
            }
        },
        methods: {
            getData: function () {
                var root = this;
                
                if (root.values != undefined && root.values != null && root.values != '') {
                    root.value = root.options.find(function (x) {
                        return x.name == root.values;
                    });
                }                
            },
        },
        computed: {
            DisplayValue: {
                get: function () {
                    if (this.value != "" || this.value != undefined) {

                        return this.value;
                    }
                    return this.value;
                },
                set: function (value) {

                    this.value = value;
                    this.$emit('input', value.name);
                }
            }
        },
        mounted: function () {
            var root = this;
            root.options.push({ name: 'Afghanistan' });
            root.options.push({ name: 'Åland Islands' });
            root.options.push({ name: 'Albania' });
            root.options.push({ name: 'Algeria' });
            root.options.push({ name: 'American Samoa' });
            root.options.push({ name: 'Andorra' });
            root.options.push({ name: 'Angola' });
            root.options.push({ name: 'Anguilla' });
            root.options.push({ name: 'Antarctica' });
            root.options.push({ name: 'Antigua and Barbuda' });
            root.options.push({ name: 'Argentina' });
            root.options.push({ name: 'Armenia' });
            root.options.push({ name: 'Aruba' });
            root.options.push({ name: 'Australia' });
            root.options.push({ name: 'Austria' });
            root.options.push({ name: 'Azerbaijan' });
            root.options.push({ name: 'Bahamas' });
            root.options.push({ name: 'Bahrain' });
            root.options.push({ name: 'Bangladesh' });
            root.options.push({ name: 'Barbados' });
            root.options.push({ name: 'Belarus' });
            root.options.push({ name: 'Belgium' });
            root.options.push({ name: 'Belize' });
            root.options.push({ name: 'Benin' });
            root.options.push({ name: 'Bermuda' });
            root.options.push({ name: 'Bhutan' });
            root.options.push({ name: 'Bolivia, Plurinational State of' });
            root.options.push({ name: 'Bonaire, Sint Eustatius and Saba' });
            root.options.push({ name: 'Bosnia and Herzegovina' });
            root.options.push({ name: 'Botswana' });
            root.options.push({ name: 'Bouvet Island' });
            root.options.push({ name: 'Brazil' });
            root.options.push({ name: 'British Indian Ocean Territory' });
            root.options.push({ name: 'Brunei Darussalam' });
            root.options.push({ name: 'Bulgaria' });
            root.options.push({ name: 'Burkina Faso' });
            root.options.push({ name: 'Burundi' });
            root.options.push({ name: 'Cambodia' });
            root.options.push({ name: 'Cameroon' });
            root.options.push({ name: 'Canada' });
            root.options.push({ name: 'Cape Verde' });
            root.options.push({ name: 'Cayman Islands' });
            root.options.push({ name: 'Central African Republic' });
            root.options.push({ name: 'Chad' });
            root.options.push({ name: 'Chile' });
            root.options.push({ name: 'China' });
            root.options.push({ name: 'Christmas Island' });
            root.options.push({ name: 'Cocos (Keeling) Islands' });
            root.options.push({ name: 'Colombia' });
            root.options.push({ name: 'Comoros' });
            root.options.push({ name: 'Congo' });
            root.options.push({ name: 'Congo, the Democratic Republic of the' });
            root.options.push({ name: 'Cook Islands' });
            root.options.push({ name: 'Costa Rica' });
            root.options.push({ name: 'Côte dIvoire' });
            root.options.push({ name: 'Croatia' });
            root.options.push({ name: 'Cuba' });
            root.options.push({ name: 'Curaçao' });
            root.options.push({ name: 'Cyprus' });
            root.options.push({ name: 'Czech Republic' });
            root.options.push({ name: 'Denmark' });
            root.options.push({ name: 'Djibouti' });
            root.options.push({ name: 'Dominica' });
            root.options.push({ name: 'Dominican Republic' });
            root.options.push({ name: 'Ecuador' });
            root.options.push({ name: 'Egypt' });
            root.options.push({ name: 'El Salvador' });
            root.options.push({ name: 'Equatorial Guinea' });
            root.options.push({ name: 'Eritrea' });
            root.options.push({ name: 'Estonia' });
            root.options.push({ name: 'Ethiopia' });
            root.options.push({ name: 'Falkland Islands (Malvinas)' });
            root.options.push({ name: 'Faroe Islands' });
            root.options.push({ name: 'Fiji' });
            root.options.push({ name: 'Finland' });
            root.options.push({ name: 'France' });
            root.options.push({ name: 'French Guiana' });
            root.options.push({ name: 'French Polynesia' });
            root.options.push({ name: 'French Southern Territories' });
            root.options.push({ name: 'Gabon' });
            root.options.push({ name: 'Gambia' });
            root.options.push({ name: 'Georgia' });
            root.options.push({ name: 'Germany' });
            root.options.push({ name: 'Ghana' });
            root.options.push({ name: 'Gibraltar' });
            root.options.push({ name: 'Greece' });
            root.options.push({ name: 'Greenland' });
            root.options.push({ name: 'Grenada' });
            root.options.push({ name: 'Guadeloupe' });
            root.options.push({ name: 'Guam' });
            root.options.push({ name: 'Guatemala' });
            root.options.push({ name: 'Guernsey' });
            root.options.push({ name: 'Guinea' });
            root.options.push({ name: 'Guinea-Bissau' });
            root.options.push({ name: 'Guyana' });
            root.options.push({ name: 'Haiti' });
            root.options.push({ name: 'Heard Island and McDonald Islands' });
            root.options.push({ name: 'Holy See (Vatican City State)' });
            root.options.push({ name: 'Honduras' });
            root.options.push({ name: 'Hong Kong' });
            root.options.push({ name: 'Hungary' });
            root.options.push({ name: 'Iceland' });
            root.options.push({ name: 'India' });
            root.options.push({ name: 'Indonesia' });
            root.options.push({ name: 'Iran, Islamic Republic of' });
            root.options.push({ name: 'Iraq' });
            root.options.push({ name: 'Ireland' });
            root.options.push({ name: 'Isle of Man' });
            root.options.push({ name: 'Israel' });
            root.options.push({ name: 'Italy' });
            root.options.push({ name: 'Jamaica' });
            root.options.push({ name: 'Japan' });
            root.options.push({ name: 'Jersey' });
            root.options.push({ name: 'Jordan' });
            root.options.push({ name: 'Kazakhstan' });
            root.options.push({ name: 'Kenya' });
            root.options.push({ name: 'Kiribati' });
            root.options.push({ name: 'Korea, Democratic Peoples Republic of' });
            root.options.push({ name: 'Korea, Republic of' });
            root.options.push({ name: 'Kuwait' });
            root.options.push({ name: 'Kyrgyzstan' });
            root.options.push({ name: 'Lao Peoples Democratic Republic' });
            root.options.push({ name: 'Latvia' });
            root.options.push({ name: 'Lebanon' });
            root.options.push({ name: 'Lesotho' });
            root.options.push({ name: 'Liberia' });
            root.options.push({ name: 'Libya' });
            root.options.push({ name: 'Liechtenstein' });
            root.options.push({ name: 'Lithuania' });
            root.options.push({ name: 'Luxembourg' });
            root.options.push({ name: 'Macao' });
            root.options.push({ name: 'Macedonia, the former Yugoslav Republic of' });
            root.options.push({ name: 'Madagascar' });
            root.options.push({ name: 'Malawi' });
            root.options.push({ name: 'Malaysia' });
            root.options.push({ name: 'Maldives' });
            root.options.push({ name: 'Mali' });
            root.options.push({ name: 'Malta' });
            root.options.push({ name: 'Marshall Islands' });
            root.options.push({ name: 'Martinique' });
            root.options.push({ name: 'Mauritania' });
            root.options.push({ name: 'Mauritius' });
            root.options.push({ name: 'Mayotte' });
            root.options.push({ name: 'Mexico' });
            root.options.push({ name: 'Micronesia, Federated States of' });
            root.options.push({ name: 'Moldova, Republic of' });
            root.options.push({ name: 'Monaco' });
            root.options.push({ name: 'Mongolia' });
            root.options.push({ name: 'Montenegro' });
            root.options.push({ name: 'Montserrat' });
            root.options.push({ name: 'Morocco' });
            root.options.push({ name: 'Mozambique' });
            root.options.push({ name: 'Myanmar' });
            root.options.push({ name: 'Namibia' });
            root.options.push({ name: 'Nauru' });
            root.options.push({ name: 'Nepal' });
            root.options.push({ name: 'Netherlands' });
            root.options.push({ name: 'New Caledonia' });
            root.options.push({ name: 'New Zealand' });
            root.options.push({ name: 'Nicaragua' });
            root.options.push({ name: 'Niger' });
            root.options.push({ name: 'Nigeria' });
            root.options.push({ name: 'Niue' });
            root.options.push({ name: 'Norfolk Island' });
            root.options.push({ name: 'Northern Mariana Islands' });
            root.options.push({ name: 'Norway' });
            root.options.push({ name: 'Oman' });
            root.options.push({ name: 'Pakistan' });
            root.options.push({ name: 'Palau' });
            root.options.push({ name: 'Palestinian Territory, Occupied' });
            root.options.push({ name: 'Panama' });
            root.options.push({ name: 'Papua New Guinea' });
            root.options.push({ name: 'Paraguay' });
            root.options.push({ name: 'Peru' });
            root.options.push({ name: 'Philippines' });
            root.options.push({ name: 'Pitcairn' });
            root.options.push({ name: 'Poland' });
            root.options.push({ name: 'Portugal' });
            root.options.push({ name: 'Puerto Rico' });
            root.options.push({ name: 'Qatar' });
            root.options.push({ name: 'Réunion' });
            root.options.push({ name: 'Romania' });
            root.options.push({ name: 'Russian Federation' });
            root.options.push({ name: 'Rwanda' });
            root.options.push({ name: 'Saint Barthélemy' });
            root.options.push({ name: 'Saint Helena, Ascension and Tristan da Cunha' });
            root.options.push({ name: 'Saint Kitts and Nevis' });
            root.options.push({ name: 'Saint Lucia' });
            root.options.push({ name: 'Saint Martin (French part)' });
            root.options.push({ name: 'Saint Pierre and Miquelon' });
            root.options.push({ name: 'Saint Vincent and the Grenadines' });
            root.options.push({ name: 'Samoa' });
            root.options.push({ name: 'San Marino' });
            root.options.push({ name: 'Sao Tome and Principe' });
            root.options.push({ name: 'Saudi Arabia' });
            root.options.push({ name: 'Senegal' });
            root.options.push({ name: 'Serbia' });
            root.options.push({ name: 'Seychelles' });
            root.options.push({ name: 'Sierra Leone' });
            root.options.push({ name: 'Singapore' });
            root.options.push({ name: 'Sint Maarten (Dutch part)' });
            root.options.push({ name: 'Slovakia' });
            root.options.push({ name: 'Slovenia' });
            root.options.push({ name: 'Solomon Islands' });
            root.options.push({ name: 'Somalia' });
            root.options.push({ name: 'South Africa' });
            root.options.push({ name: 'South Georgia and the South Sandwich Islands' });
            root.options.push({ name: 'South Sudan' });
            root.options.push({ name: 'Spain' });
            root.options.push({ name: 'Sri Lanka' });
            root.options.push({ name: 'Sudan' });
            root.options.push({ name: 'Suriname' });
            root.options.push({ name: 'Svalbard and Jan Mayen' });
            root.options.push({ name: 'Swaziland' });
            root.options.push({ name: 'Sweden' });
            root.options.push({ name: 'Switzerland' });
            root.options.push({ name: 'Syrian Arab Republic' });
            root.options.push({ name: 'Taiwan, Province of China' });
            root.options.push({ name: 'Tajikistan' });
            root.options.push({ name: 'Tanzania, United Republic of' });
            root.options.push({ name: 'Thailand' });
            root.options.push({ name: 'Timor-Leste' });
            root.options.push({ name: 'Togo' });
            root.options.push({ name: 'Tokelau' });
            root.options.push({ name: 'Tonga' });
            root.options.push({ name: 'Trinidad and Tobago' });
            root.options.push({ name: 'Tunisia' });
            root.options.push({ name: 'Turkey' });
            root.options.push({ name: 'Turkmenistan' });
            root.options.push({ name: 'Turks and Caicos Islands' });
            root.options.push({ name: 'Tuvalu' });
            root.options.push({ name: 'Uganda' });
            root.options.push({ name: 'Ukraine' });
            root.options.push({ name: 'United Arab Emirates' });
            root.options.push({ name: 'United Kingdom' });
            root.options.push({ name: 'United States' });
            root.options.push({ name: 'United States Minor Outlying Islands' });
            root.options.push({ name: 'Uruguay' });
            root.options.push({ name: 'Uzbekistan' });
            root.options.push({ name: 'Vanuatu' });
            root.options.push({ name: 'Venezuela, Bolivarian Republic of' });
            root.options.push({ name: 'Viet Nam' });
            root.options.push({ name: 'Virgin Islands, British' });
            root.options.push({ name: 'Virgin Islands, U.S.' });
            root.options.push({ name: 'Wallis and Futuna' });
            root.options.push({ name: 'Western Sahara' });
            root.options.push({ name: 'Yemen' });
            root.options.push({ name: 'Zambia' });
            root.options.push({ name: 'Zimbabwe' });



            this.getData();
        },
    }
</script>